import { useCallback } from 'preact/hooks';

import { useJWPlayerEvent } from './useJWPlayerEvent';
import { useTracker } from './useTracker';

export const useChromecastTracking = () => {
  const {
    trackChromecastStarting,
    trackChromecastStarted,
    trackChromecastEnded,
  } = useTracker();

  const handleCastSessionStateChanged = useCallback(
    ({ sessionState, duration }: jwplayer.CastSessionStateChangedParam) => {
      switch (sessionState) {
        case cast.framework.SessionState.SESSION_STARTING:
          trackChromecastStarting();

          break;
        case cast.framework.SessionState.SESSION_STARTED:
          trackChromecastStarted();

          break;
        case cast.framework.SessionState.SESSION_ENDED:
          trackChromecastEnded(duration!);

          break;
        default:
          break;
      }
    },
    [trackChromecastStarting, trackChromecastStarted, trackChromecastEnded]
  );

  useJWPlayerEvent('castSessionStateChanged', handleCastSessionStateChanged);
};
